function resetCardGroups($root) {
    if ($root.hasClass('hs-card-groups--single')) {
        return;
    }

    $root.removeClass('is-showing-all');
    $root.find('[data-testid="hs-card-group-icon"]')
        .attr('aria-expanded', 'false')
        .removeClass('is-open');
    $root.find('[data-testid="hs-card-group-panel"]').prop('hidden', true);
    $root.find('[data-testid="hs-card-group-show-all"]')
        .attr('aria-expanded', 'false')
        .removeClass('is-open')
        .text($root.attr('data-show-all-label') || 'Show all');
}

$(function initProductCardGroups() {
    $(document).on('click', '[data-hs-card-groups] [data-testid="hs-card-group-icon"]', function onGroupIconClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const $button = $(this);
        const $root = $button.closest('[data-hs-card-groups]');
        if (!$root.length) {
            return;
        }

        const panelId = $button.attr('aria-controls');
        const wasOpen = $button.attr('aria-expanded') === 'true' && !$root.hasClass('is-showing-all');

        resetCardGroups($root);

        if (wasOpen || !panelId) {
            return;
        }

        $button.attr('aria-expanded', 'true').addClass('is-open');
        $root.find('[id="' + panelId + '"]').prop('hidden', false);
    });

    $(document).on('click', '[data-hs-card-groups] [data-testid="hs-card-group-show-all"]', function onShowAllClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const $button = $(this);
        const $root = $button.closest('[data-hs-card-groups]');
        if (!$root.length) {
            return;
        }

        const wasOpen = $button.attr('aria-expanded') === 'true';
        resetCardGroups($root);

        if (wasOpen) {
            return;
        }

        $root.addClass('is-showing-all');
        $root.find('[data-testid="hs-card-group-panel"]').prop('hidden', false);
        $button
            .attr('aria-expanded', 'true')
            .addClass('is-open')
            .text($root.attr('data-hide-label') || 'Hide');
    });
});
